/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsumerTaskStatus {
    NotStarted = 'NotStarted',
    Processing = 'Processing',
    Complete = 'Complete',
    Error = 'Error'
}

export function ConsumerTaskStatusFromJSON(json: any): ConsumerTaskStatus {
    return ConsumerTaskStatusFromJSONTyped(json, false);
}

export function ConsumerTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerTaskStatus {
    return json as ConsumerTaskStatus;
}

export function ConsumerTaskStatusToJSON(value?: ConsumerTaskStatus | null): any {
    return value as any;
}

